<!-- Control actividad/proveedores -->

<template>
  <div class="expControlM" v-if="loaded">

    <div class="contenedor" style="padding:10px 50px 0 50px">
      <template v-if="!iniValoracion && !fechaFin">
        <span style="font-size:16px;color:red">Debe introducir Inicio y Tipo para comenzar la valoración</span>
      </template>

      <div class="conflex" style="justify-content:left;align-items:center">

        <div class="conflex" style="align-items:center">

          <div class="columna">
            <div class="cab" style="background-color:red">Inicio Valoración</div>
            <div style="color:steelblue;">
              <v-sheet v-bind="$cfg.styles.marco">
                <v-text-field
                  style="width:200px"
                  v-bind="$input"
                  v-model="ct.fhini[2]"
                  :label="ct.fhini[1]"
                  readonly
                  :disabled="ct.fhini[2]!=''"
                  append-icon="mdi-calendar"
                  @click:append="setFhIni" />
              </v-sheet>
            </div>
          </div>

          <div class="columna" style="margin-left:10px">
            <div class="cab" style="background-color:red">Tipo Valoración</div>
            <div style="color:steelblue;">
              <v-sheet v-bind="$cfg.styles.marco">
                <div >
                  <v-radio-group style="margin:5px;" row v-model="getTipo" dense :disabled="estado== 'ver'">
                    <v-radio
                      style="margin-left:10px"
                      v-for="n in 2"
                      :key="n"
                      :label="n==1? 'Incidencia' : 'Control'"
                      :value="n"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </v-sheet>
            </div>
          </div>

          <div class="columna" style="margin-left:10px">
            <div class="cab" style="background-color:red">Fin Valoración</div>
            <div style="color:steelblue;">
              <v-sheet v-bind="$cfg.styles.marco">
                <v-text-field
                  style="width:200px;margin-left:10px"
                  v-bind="$input"
                  v-model="fechaFin"
                  :label="ct.fhfin[1]"
                  readonly
                  append-icon="mdi-calendar"
                  @click:append="setFhFin" />
              </v-sheet>
            </div>
          </div>
        </div>

        <div>
          <template v-if="!fechaFin && iniValoracion">
            <baseBtraMto
              :perm="permMto"
              :modulo="btMtoCfg"
              :estado="estado"
              @onEvent="execAccion">
            </baseBtraMto>
          </template>

          <template v-if="$store.state.G.ZONA==0 && fechaFin">            
            <v-btn v-if="$store.state.login_estado"        
              color="blue-grey lighten-2"
              small             
              style="margin-right:200px"
              @click="abrirValoracion">   
                <div class="flex" style="align-items:center">                  
                  <span style="color:white;padding-left:5px">Reabrir C. Actividad</span>
                </div>
            </v-btn>           
          </template>
        </div>
      </div>

      <div v-if="iniValoracion" >
        <div class="conflex" style="padding-top:15px">
          <div class="columna">

            <expControlComp
              :grupo=0
              :seleccion="ct.apd_ID"
              :val="ct.datavaloracion"
              :obs="ct.apd_obs"
              :dataAux="apds"
              :valoraciones="valoracionesApd"
              titulo="APD"
              :disabled="!edicion"
              @changeSeleccion="changeApd">
            </expControlComp>
          </div>

          <div class="columna">
            <expControlComp
              :grupo=1
              :seleccion="ct.funeraria_ID"
              :val="ct.datavaloracion"
              :obs="ct.funeraria_obs"
              :dataAux="funerarios"
              :valoraciones="valoracionesFunerario"
              titulo="FUNERARIO"
              :disabled="!edicion"
              @changeSeleccion="changeFuneraria">
            </expControlComp>
          </div>

          <div class="columna">
            <expControlComp
              :grupo=2
              :seleccion="ct.tanatorio"
              :val="ct.datavaloracion"
              :obs="ct.tanatorio_obs"
              :valoraciones="valoracionesTanatorio"
              titulo="TANATORIO"
              :disabled="!edicion">
            </expControlComp>
          </div>
        </div>

        <div class="conflex mt-2">
          <div class="columna">
            <expControlComp
              :grupo=3
              :seleccion="ct.flores"
              :val="ct.datavaloracion"
              :obs="ct.flores_obs"
              :valoraciones="valoracionesFlores"
              titulo="FLORES"
              :disabled="!edicion"
              height="250px">
            </expControlComp>
          </div>

          <div class="columna">
            <expControlComp
              :grupo=4
              :seleccion="ct.lapida"
              :val="ct.datavaloracion"
              :obs="ct.lapida_obs"
              :valoraciones="valoracionesLapida"
              titulo="LAPIDA"
              :disabled="!edicion"
              height="250px">
            </expControlComp>
          </div>

          <div class="columna">
            <expControlComp
              :grupo=5
              :seleccion="ct.gestoria"
              :val="ct.datavaloracion"
              :obs="ct.gestoria_obs"
              :valoraciones="valoracionesGestoria"
              titulo="GESTORÍA"
              :disabled="!edicion"
              height="250px">
            </expControlComp>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>

  import { mixM } from "@/mixins/mixM.js";
  import baseBtraMto from "@/base/baseBtraMto";  
  import expControlComp from "@/components/expControlComp";

  export default {
    mixins: [mixM],
    components: {
      expControlComp,
      baseBtraMto      
    },

    props: {
      id: { type:String, default:'' },
      tab: { type:Number, default:0 }
    },

    data() {
      return {
        stIni: {
          api: "expControlM",
          name:"expControlM",
          titulo:"Control Actividad / Proveedores",
          recordAccess:"local",
          mView:'',
          pView:[]
        },

        apds:[],
        valoracionesApd:[],
        funerarios:[],
        valoracionesFunerario:[],
        valoracionesTanatorio:[],
        valoracionesFlores:[],
        valoracionesLapida:[],
        valoracionesGestoria:[],

      };
    },




    methods: {
      iniDataParticular() {
        console.log("DEV " + this.stIni.api + " ********************** (iniDataParticular)");
       
        this.valoracionesApd= [
          { name:'Tiempo de respuesta', val:'' },
          { name:'Información coberturas póliza', val:'' },
          { name:'Información sobre servicio a prestar', val:'' },
          { name:'Actitud y presencia', val:'' },
          { name:'Cumplimentación de datos', val:'' }
        ]

        this.valoracionesFunerario= [
          { name:'Arca/Elección de arcas', val:'' },
          { name:'Personal (presencia y actitud', val:'' },
          { name:'Trámites y gestiones', val:'' },
          { name:'Coche funerario', val:'' }
        ]

        this.valoracionesTanatorio= [
          { name:'Instalaciones', val:'' },
          { name:'Mobiliario', val:'' },
          { name:'Personal', val:'' }
        ]

        this.valoracionesFlores= [
          { name:'Calidad', val:'' },
          { name:'Horarios de entrega', val:'' }
        ]

        this.valoracionesLapida= [
          { name:'Calidad', val:'' },
          { name:'Plazos de terminación', val:'' }
        ]

        this.valoracionesGestoria= [
          { name:'Información facilitada al cliente', val:'' },
          { name:'Plazos de entrega', val:'' }
        ]
        
      },


      // inicializo variables Btra Mto
      iniBtra() {
        this.btMtoCfg= JSON.parse(JSON.stringify(this.$cfe.btra.MEDIT));       
      },


      // acción a ejecutar al crear el componente y cada vez que cambia su id o de tab
      // recarga valoraciones del expediente
      // obtiene apds y funerarias que intervienen en el expte
      // asigna datos del expte al schema
      async buscar() {
        await this.ver();
        this.getExpData();
        this.setExpData();
      },


      // gancho al terminar de leer el registro de la bd
      // pone estado del mto en indefindo si no hay registro
      // y en ver si lo hay
      async verFin() {
        if (!Object.keys(this.record).length) return await this.$store.commit(this.storeName + '/cancelarUpdate');
        this.$store.commit(this.storeName + '/verUpdate');
      },


      // gancho antes de obtener el record de datos a guardar
      // si es un nuevo, obtiene todos los datos del schema, hayan cambiado o no
      // si es un editar, solo envia los campos modificados
      getRecordChangesToSave() {
        return this.ctrl2record(this.ct, this.record, this.estado=='nuevo'? false : true);
      },


      // gancho antes de guardar
      // añade el id del expediente al record a guardar
      guardarBeforeAPI(recordChanges) {
        if (recordChanges.fhini) recordChanges.fhini= this.$options.filters['fechahr'](recordChanges.fhini, 'visual2sql');
        if (recordChanges.fhfin) recordChanges.fhfin= this.$options.filters['fechahr'](recordChanges.fhfin, 'visual2sql');
        recordChanges.exp_ID= this.id;
      },


      // entra al cancelar la edición de un registro
      // si es un nuevo, cancelar estado, inicializa schema y guarda datos del expte
      // si es un editar, recarga datos
      async cancelarSi() {
        if (this.estado=='nuevo') {
          await this.$store.commit(this.storeName + '/cancelarUpdate');
          this.ctIni();
          this.setExpData();
          return;
        }

        this.execAccion({ accion: 0 });
      },


      // asigna fecha actual como inicio de valoración
      setFhIni() {
        let fhActual= this.$options.filters['fechahr'](this.actualDateTime());
        this.$set(this.ct.fhini, 2, fhActual);
      },


      // asigna fecha actual como fin de valoración
      // ya no se podrá editar de nuevo el mto
      setFhFin() {
        if (!this.edicion) return;

        this.$root.$alert.open('¿Desea finalizar la valoración?<br>Una vez finalizada no podrá modificarse', 'confirm')
        .then(r=> { if (r) this.setFhFin_continue() });
      },

      setFhFin_continue() {
        let fhActual= this.$options.filters['fechahr'](this.actualDateTime());
        this.$set(this.ct.fhfin, 2, fhActual);

        this.guardar();
      },



      // obtener datos del expediente
      getExpData() {
        if (!Object.keys(this.recordAux).length) return;

        this.apds= this.getApds();
        this.funerarios= this.getFunerarios();
      },


      // obtiene apds que intervienen en el expediente
      getApds() {
        let apds= [];
        if (Number(this.recordAux.apd1)> 0) apds.push({ apd:1, name:this.recordAux.name_apd1, val:this.recordAux.apd1 });
        if (Number(this.recordAux.apd2)> 0) apds.push({ apd:2, name:this.recordAux.name_apd2, val:this.recordAux.apd2 });

        return apds;
      },


      // guardar en el schema datos del expediente
      setExpData() {
        if (!Object.keys(this.recordAux).length) return;

        this.setApds();
        this.setFunerarios();
      },


      // asigna apd seleccionado al schema y la zona del mismo
      setApds() {
        // si el expte tiene apd1 y no hay ninguno seleccionado,
        // lo selecciona y asigna su zona
        if (Number(this.recordAux.apd1)> 0 && !this.ct.apd_ID[2]) {
          this.$set(this.ct.apd_ID, 2, this.recordAux.apd1);
          this.$set(this.ct.zona_ID, 2, this.recordAux.zona_apd1);
        }

        // si el expte tiene apd2 y no hay ninguno seleccionado,
        // lo selecciona y asigna su zona
        if (Number(this.recordAux.apd2)> 0 && !this.ct.apd_ID[2]) {
          this.$set(this.ct.apd_ID, 2, this.recordAux.apd2);
          this.$set(this.ct.zona_ID, 2, this.recordAux.zona_apd2);
        }

        // si no tiene apd1 ni apd2, guarda zona origen
        if ((Number(this.recordAux.apd1)== 0) && (Number(this.recordAux.apd2)== 0)) {
          this.$set(this.ct.zona_ID, 2, this.recordAux.zona_origen);
        }
      },


      // funerarios que intervienen en el expediente
      getFunerarios() {
        let funerarios= [];
        if (Number(this.recordAux.fune1)> 0) funerarios.push({ name:this.recordAux.name_fune1, val:this.recordAux.fune1 });
        if (Number(this.recordAux.fune2)> 0) funerarios.push({ name:this.recordAux.name_fune2, val:this.recordAux.fune2 });

        return funerarios;
      },


      // asigna funeraria seleccionada al schema y los datos de tanatorio, flores y lápida
      setFunerarios() {
        // si el expte tiene fune1 y no hay ninguna seleccionada,
        // la selecciona y cambia datos de tanatorio, flores y lápida
        if (Number(this.recordAux.fune1)> 0 && !this.ct.funeraria_ID[2]) {
          this.$set(this.ct.funeraria_ID, 2, this.recordAux.fune1);
          this.changeFuneraria(this.recordAux.name_fune1);
        }

        // si el expte tiene fune2 y no hay ninguna seleccionada,
        // la selecciona y cambia datos de tanatorio, flores y lápida
        if (Number(this.recordAux.fune2)> 0 && !this.ct.funeraria_ID[2]) {
          this.$set(this.ct.funeraria_ID, 2, this.recordAux.fune2);
          this.changeFuneraria(this.recordAux.name_fune2);
        }
      },


      // entra al seleccionar una funeraría
      // actualiza la zona del apd según el que está seleccionado
      changeApd(apd) {
        this.$set(this.ct.zona_ID, 2, this.recordAux['zona_apd' + apd]);
      },


      // entra al seleccionar una funeraría
      // pone el mismo nombre de la funeraria en tanatorio, flores y lápida
      changeFuneraria(funeraria) {
        this.$set(this.ct.tanatorio, 2, funeraria);
        this.$set(this.ct.flores, 2, funeraria);
        this.$set(this.ct.lapida, 2, funeraria);
      },


      //
      abrirValoracion() {
        this.$root.$alert.open("¿Desea abrir C. Actividad?","confirm")
          .then((r)=>this.abrirValoracion_respuesta(r));
      },

      async abrirValoracion_respuesta(r) {
        if (!r) return;
        await this.editar();
        this.$set(this.ct.fhfin, 2, null);
        await this.guardar();
      }


    },



    computed: {

      ID() {
        return this.id;
      },


      // devuelve/asigna tipo de valoración
      getTipo: {
        get() {
          return Number(this.ct.tipo[2]);
        },

        set(val) {
          this.$set(this.ct.tipo, 2, val);
        }
      },


      // true: cuando se ha iniciado la valoración y está en edición
      edicion() {
        if (this.iniValoracion && (this.estado=='editar' || this.estado=='nuevo')) return true;
        return false;
      },


      // true: cuando la fecha de inicio de la valoración y el tipo de valoración tienen valor
      iniValoracion() {
        if (!this.loaded) return false;
        if (this.ct.fhini[2]!= '' && this.ct.tipo[2]> 0) return true;
        return false;
      },


      // devuelve/asigna fecha fin de valoración
      fechaFin: {
        get() {
          if (this.ct.fhfin[2]== '0000-00-00 00:00:00') return '';
          return this.$options.filters['fechahr'](this.ct.fhfin[2]);
        },

        set() {}

      }

    },


    watch: {
      // detecta al cambiar de expediente
      // al cambiar de expediente, hace una llamada a la API
      // para obtener las valoraciones
      // si no esta activa la pestaña de valoraciones en la ventana de expedientes, no lee
      id: {
        handler() {
          if (this.tab!= 7) return;
          this.$store.commit(this.storeName + '/disparoSet');
        }
      },


      // detecta al cambiar de pestaña
      // si la pestaña de valoraciones está activa y no está en edición, lee
      tab: {
        handler() {
          if (this.tab!= 7 || this.estado=='editar' || this.estado=='nuevo') return;
          this.$store.commit(this.storeName + '/disparoSet');
        }
      },


      // watch para controlar cuando se inicia una valoración
      // al iniciarse una valoración, carga datos  del expediente
      iniValoracion: {
        async handler() {
          if (!this.iniValoracion) return;

          // pone estado a 'nuevo'
          await this.$store.commit(this.storeName + '/nuevoUpdate');
        }
      }
    }

  };
</script>



<style  scoped>
  .v-input--radio-group.v-input--radio-group--row .v-radio {
    margin-right: 0px;
  }
</style>